import { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function KeurwijzerPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isSeen, setIsSeen] = useState(
    () => sessionStorage.getItem("keurwijzer-popup-seen") === "true",
  );

  useEffect(() => {
    if (isSeen) return;

    const timeout = window.setTimeout(() => {
      setIsVisible(true);
      sessionStorage.setItem("keurwijzer-popup-seen", "true");
      setIsSeen(true);
    }, 4000);

    return () => window.clearTimeout(timeout);
  }, [isSeen]);

  const handleClose = () => {
    setIsVisible(false);
    setIsSeen(true);
    sessionStorage.setItem("keurwijzer-popup-seen", "true");
  };

  return (
    <>
      {isVisible && (
        <aside className="keurwijzer-popup">
          <div className="absolute right-1 top-2">
            <button
              type="button"
              className="keurwijzer-popup__close"
              onClick={handleClose}
              aria-label="Sluiten"
            >
              <X size={18} />
            </button>
          </div>

          <div className="keurwijzer-popup__content">
            <span className="keurwijzer-popup__eyebrow">
              Trots op onze erkenning
            </span>

            <h3>Uw schilderwerken in vertrouwde handen</h3>

            <p>
              Met trots behoren wij tot de best beoordeelde schilders in regio
              Kortrijk in 2026. Ontdek onze erkenning via Keurwijzer.
            </p>

            <a
              className="keurwijzer-badge"
              href="https://keurwijzer.be/schilderwerken-kortrijk/"
              title="Keurwijzer: Best beoordeeld bij de schilders in regio Kortrijk (2026)"
            >
              <img
                src="https://badges.keurwijzer.be/4pxrmu-light.png"
                alt="Keurwijzer: Best beoordeeld bij de schilders in regio Kortrijk (2026)"
                width="318"
                height="90"
                style={{ maxWidth: "200px", height: "auto" }}
                loading="lazy"
              />
            </a>
          </div>
        </aside>
      )}

      {isSeen && !isVisible && (
        <div className="keurwijzer-fixed-badge">
          <a
            className="keurwijzer-badge"
            href="https://keurwijzer.be/schilderwerken-kortrijk/"
            title="Keurwijzer: Best beoordeeld bij de schilders in regio Kortrijk (2026)"
          >
            <img
              src="https://badges.keurwijzer.be/4pxrmu-light.png"
              alt="Keurwijzer: Best beoordeeld bij de schilders in regio Kortrijk (2026)"
              width="318"
              height="90"
              style={{ maxWidth: "200px", height: "auto" }}
              loading="lazy"
            />
          </a>
        </div>
      )}
    </>
  );
}
